import { FC, memo } from 'react';
import styles from './index.less';

interface BottomButtonsProps {
  /**提交按钮文字*/
  submitBtnText?: string;
  /**提交按钮点击函数*/
  submitBtnClick?: () => void;
}

const BottomButtons: FC<BottomButtonsProps> = ({
  submitBtnText = '提交',
  submitBtnClick,
}) => {
  return (
    <div className={styles.container}>
      <div onClick={submitBtnClick} className={styles['submit-btn']}>
        {submitBtnText}
      </div>
    </div>
  );
};
export default memo(BottomButtons);
